import React, { useEffect, useState } from 'react';
import { inmueblesService, contratosService, documentosService, API_BASE } from '../services/api';
import { DEPARTAMENTOS, CODIGOS_POSTALES, LOCALIDADES_POR_DEPTO } from '../data/uruguay';
import Documentos from '../components/Documentos';

const ESTADO_LABELS = {
  disponible: 'Disponible',
  alquilado: 'Alquilado',
  en_venta: 'En venta',
  vendido: 'Vendido',
  mantenimiento: 'Mantenimiento',
};

const TIPOS = ['apartamento', 'casa', 'local_comercial', 'terreno', 'oficina', 'otro'];

const FORM_VACIO = {
  nombre: '', tipo: 'apartamento', direccion: '', urbanizacion: '', ciudad: 'Punta del Este',
  localidad: '', departamento: 'Maldonado', pais: 'Uruguay', codigo_postal: '',
  superficie_total: '', dormitorios: '', banos: '', garaje: false, estado: 'disponible',
  es_propio: true, padron: '', notas: '', latitud: '', longitud: '', google_maps_url: ''
};

function ContratosFicha({ contratos, docs }) {
  const activo = contratos.find(c => c.estado === 'activo');
  const historicos = contratos.filter(c => c.estado !== 'activo');
  const docsActivo = activo && docs[activo.id] ? docs[activo.id] : [];
  return (
    <>
      <hr style={{ border: 'none', borderTop: '1px solid #f0f0f0', margin: '16px 0' }} />
      {activo && (
        <div style={{ background: '#eafaf1', borderRadius: 10, padding: '12px 16px', marginBottom: 10 }}>
          <div style={{ fontSize: '0.75rem', fontWeight: 700, color: '#27ae60', textTransform: 'uppercase', marginBottom: 6 }}>Contrato activo</div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '4px 20px', fontSize: '0.86rem', color: '#444' }}>
            <p>👤 {activo.inquilino_nombre} {activo.inquilino_apellido}</p>
            <p>💵 {activo.moneda} {parseFloat(activo.monto).toLocaleString()}/mes</p>
            <p>📅 {new Date(activo.fecha_inicio).toLocaleDateString('es-UY')} → {activo.fecha_fin ? new Date(activo.fecha_fin).toLocaleDateString('es-UY') : 'Indefinido'}</p>
            {activo.garante_nombre && <p>🛡 {activo.garante_nombre}</p>}
            {activo.inmobiliaria && <p>🏢 {activo.inmobiliaria}</p>}
            {activo.deposito && <p>🔒 Depósito: {activo.moneda_deposito} {parseFloat(activo.deposito).toLocaleString()}</p>}
          </div>
          {docsActivo.length > 0 && (
            <div style={{ marginTop: 10, borderTop: '1px solid #c8f0d8', paddingTop: 8 }}>
              <div style={{ fontSize: '0.75rem', color: '#27ae60', marginBottom: 4 }}>📎 Documentos del contrato</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                {docsActivo.map(doc => (
                  <a key={doc.id}
                    href={doc.archivo_url.startsWith('http') ? doc.archivo_url : `${API_BASE}${doc.archivo_url}`}
                    target="_blank" rel="noreferrer"
                    style={{ fontSize: '0.82rem', color: '#4f8ef7', textDecoration: 'none' }}>
                    📄 {doc.nombre}
                  </a>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
      {historicos.length > 0 && (
        <details style={{ marginBottom: 8 }}>
          <summary style={{ fontSize: '0.82rem', color: '#888', cursor: 'pointer' }}>
            Historial de contratos ({historicos.length})
          </summary>
          <div style={{ marginTop: 8, display: 'flex', flexDirection: 'column', gap: 6 }}>
            {historicos.map(c => (
              <div key={c.id} style={{ background: '#f8f9fa', borderRadius: 8, padding: '8px 12px', fontSize: '0.83rem', color: '#666' }}>
                <span style={{ fontWeight: 600 }}>{c.inquilino_nombre} {c.inquilino_apellido}</span>
                <span style={{ marginLeft: 10, color: '#aaa' }}>{new Date(c.fecha_inicio).toLocaleDateString('es-UY')} → {c.fecha_fin ? new Date(c.fecha_fin).toLocaleDateString('es-UY') : '∞'}</span>
                <span style={{ marginLeft: 10 }}>{c.moneda} {parseFloat(c.monto).toLocaleString()}/mes</span>
                {c.inmobiliaria && <span style={{ marginLeft: 10, color: '#4f8ef7' }}>· {c.inmobiliaria}</span>}
                <span style={{ marginLeft: 10, padding: '1px 8px', borderRadius: 10, background: '#f0f0f0', color: '#95a5a6', fontSize: '0.75rem' }}>{c.estado}</span>
              </div>
            ))}
          </div>
        </details>
      )}
    </>
  );
}

export default function Inmuebles() {
  const [inmuebles, setInmuebles] = useState([]);
  const [modal, setModal] = useState(false);
  const [editando, setEditando] = useState(null);
  const [detalle, setDetalle] = useState(null);
  const [contratosDetalle, setContratosDetalle] = useState([]);
  const [docsContratos, setDocsContratos] = useState({});
  const [form, setForm] = useState(FORM_VACIO);
  const [sugerenciasLocalidad, setSugerenciasLocalidad] = useState([]);
  const [vistaLista, setVistaLista] = useState(false);

  const cargar = () => inmueblesService.getAll().then(r => setInmuebles(r.data));
  useEffect(() => { cargar(); }, []);

  const handleChange = e => {
    const { name, value, type, checked } = e.target;
    const nuevoForm = { ...form, [name]: type === 'checkbox' ? checked : value };

    // Si cambia departamento, limpiar localidad y actualizar sugerencias
    if (name === 'departamento') {
      nuevoForm.localidad = '';
      setSugerenciasLocalidad(LOCALIDADES_POR_DEPTO[value] || []);
    }

    // Si cambia código postal, sugerir localidad, ciudad y departamento
    if (name === 'codigo_postal' && value.length >= 5) {
      const datos = CODIGOS_POSTALES[value];
      if (datos) {
        nuevoForm.localidad = datos.localidad;
        nuevoForm.ciudad = datos.ciudad;
        nuevoForm.departamento = datos.departamento;
        setSugerenciasLocalidad(LOCALIDADES_POR_DEPTO[datos.departamento] || []);
      }
    }

    // Si cambia localidad, intentar completar código postal
    if (name === 'localidad') {
      const entrada = Object.entries(CODIGOS_POSTALES).find(([, v]) => v.localidad === value);
      if (entrada) {
        nuevoForm.codigo_postal = entrada[0];
        nuevoForm.ciudad = entrada[1].ciudad;
      }
    }

    setForm(nuevoForm);
  };

  const abrirNuevo = () => {
    setEditando(null);
    setForm(FORM_VACIO);
    setSugerenciasLocalidad(LOCALIDADES_POR_DEPTO['Maldonado'] || []);
    setModal(true);
  };

  const abrirEditar = (inmueble) => {
    setEditando(inmueble.id);
    setForm({
      nombre: inmueble.nombre || '',
      tipo: inmueble.tipo || 'apartamento',
      direccion: inmueble.direccion || '',
      ciudad: inmueble.ciudad || '',
      urbanizacion: inmueble.urbanizacion || '',
      localidad: inmueble.localidad || '',
      departamento: inmueble.departamento || '',
      pais: inmueble.pais || 'Uruguay',
      codigo_postal: inmueble.codigo_postal || '',
      superficie_total: inmueble.superficie_total || '',
      dormitorios: inmueble.dormitorios || '',
      banos: inmueble.banos || '',
      garaje: inmueble.garaje || false,
      estado: inmueble.estado || 'disponible',
      es_propio: inmueble.es_propio !== false,
      padron: inmueble.padron || '',
      notas: inmueble.notas || '',
      latitud: inmueble.latitud || '',
      longitud: inmueble.longitud || '',
      google_maps_url: inmueble.google_maps_url || '',
    });
    setSugerenciasLocalidad(LOCALIDADES_POR_DEPTO[inmueble.departamento] || []);
    setModal(true);
  };

  const cerrarModal = () => {
    setModal(false);
    setEditando(null);
    setForm(FORM_VACIO);
  };

  const handleSubmit = async e => {
    e.preventDefault();
    if (editando) {
      await inmueblesService.update(editando, form);
    } else {
      await inmueblesService.create(form);
    }
    cerrarModal();
    cargar();
  };

  const handleEliminar = async (id, nombre) => {
    if (window.confirm(`¿Seguro que querés eliminar "${nombre}"?`)) {
      await inmueblesService.delete(id);
      cargar();
    }
  };

  return (
    <div>
      <div className="page-header">
        <h1>Inmuebles</h1>
        <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
          <div className="view-toggle">
            <button className={!vistaLista ? 'active' : ''} onClick={() => setVistaLista(false)} title="Vista tarjetas">▦ Tarjetas</button>
            <button className={vistaLista ? 'active' : ''} onClick={() => setVistaLista(true)} title="Vista lista">☰ Lista</button>
          </div>
          <button className="btn btn-primary" onClick={abrirNuevo}>+ Nuevo inmueble</button>
        </div>
      </div>

      {inmuebles.length === 0 ? (
        <div className="empty-state">
          <h3>No hay inmuebles cargados</h3>
          <p>Hacé clic en "Nuevo inmueble" para agregar tu primera propiedad</p>
        </div>
      ) : vistaLista ? (
        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Estado</th>
                <th>Dirección</th>
                <th>Tipo</th>
                <th>m²</th>
                <th>Dorm</th>
                <th>Baños</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {inmuebles.map(i => (
                <tr key={i.id} style={{ cursor: 'pointer' }} onClick={async () => {
                  setDetalle(i);
                  setContratosDetalle([]);
                  setDocsContratos({});
                  const res = await contratosService.getByInmueble(i.id);
                  setContratosDetalle(res.data);
                  const docs = {};
                  await Promise.all(res.data.map(async c => {
                    const r = await documentosService.getByEntidad('contrato', c.id);
                    docs[c.id] = r.data;
                  }));
                  setDocsContratos(docs);
                }}>
                  <td><strong>{i.nombre}</strong>{i.urbanizacion ? <span style={{ color: '#4f8ef7', fontSize: '0.78rem', marginLeft: 6 }}>{i.urbanizacion}</span> : ''}</td>
                  <td><span className={`badge ${i.estado}`}>{ESTADO_LABELS[i.estado]}</span></td>
                  <td style={{ fontSize: '0.85rem', color: '#666' }}>{i.direccion}{i.localidad ? `, ${i.localidad}` : ''}, {i.ciudad}</td>
                  <td style={{ fontSize: '0.85rem' }}>{i.tipo ? i.tipo.replace(/_/g, ' ') : '-'}</td>
                  <td>{i.superficie_total || '-'}</td>
                  <td>{i.dormitorios || '-'}</td>
                  <td>{i.banos || '-'}</td>
                  <td onClick={e => e.stopPropagation()}>
                    <div style={{ display: 'flex', gap: 4 }}>
                      <button className="btn btn-secondary" style={{ padding: '5px 10px', fontSize: '0.78rem' }} onClick={() => abrirEditar(i)}>✏️</button>
                      <button className="btn" style={{ padding: '5px 10px', fontSize: '0.78rem', background: '#fdecea', color: '#e74c3c' }} onClick={() => handleEliminar(i.id, i.nombre)}>🗑</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="cards-grid">
          {inmuebles.map(i => (
            <div key={i.id} className={`card ${i.estado}`}>
              <div className="card-header">
                <h3>{i.nombre}</h3>
                <span className={`badge ${i.estado}`}>{ESTADO_LABELS[i.estado]}</span>
              </div>
              {i.urbanizacion && <p style={{ fontSize: '0.78rem', color: '#4f8ef7', fontWeight: 600, marginBottom: 4 }}>🏘 {i.urbanizacion}</p>}
              <p>📍 {i.direccion}{i.localidad ? `, ${i.localidad}` : ''}, {i.ciudad}</p>
              {i.departamento && <p>🗺 {i.departamento}{i.codigo_postal ? ` · CP ${i.codigo_postal}` : ''}</p>}
              {i.tipo && <p>🏠 {i.tipo.replace(/_/g, ' ')}</p>}
              {i.superficie_total && <p>📐 {i.superficie_total} m²</p>}
              {(i.dormitorios || i.banos) && (
                <p>🛏 {i.dormitorios} dorm · 🚿 {i.banos} baños</p>
              )}
              {i.google_maps_url && (
                <p><a href={i.google_maps_url} target="_blank" rel="noreferrer" style={{ color: '#4f8ef7', fontSize: '0.85rem' }}>📍 Ver en Google Maps</a></p>
              )}
              {!i.es_propio && <p style={{ color: '#f39c12', fontSize: '0.8rem', marginTop: 6 }}>Administración de tercero</p>}
              <div style={{ display: 'flex', gap: 8, marginTop: 14 }}>
                <button className="btn btn-secondary" style={{ flex: 1, padding: '7px 0', fontSize: '0.82rem' }} onClick={async () => {
                  setDetalle(i);
                  setContratosDetalle([]);
                  setDocsContratos({});
                  const res = await contratosService.getByInmueble(i.id);
                  setContratosDetalle(res.data);
                  const docs = {};
                  await Promise.all(res.data.map(async c => {
                    const r = await documentosService.getByEntidad('contrato', c.id);
                    docs[c.id] = r.data;
                  }));
                  setDocsContratos(docs);
                }}>📁 Ver ficha</button>
                <button className="btn btn-secondary" style={{ padding: '7px 12px', fontSize: '0.82rem' }} onClick={() => abrirEditar(i)}>✏️</button>
                <button className="btn" style={{ padding: '7px 12px', fontSize: '0.82rem', background: '#fdecea', color: '#e74c3c' }} onClick={() => handleEliminar(i.id, i.nombre)}>🗑</button>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* MODAL FICHA DETALLE */}
      {detalle && (
        <div className="modal-overlay" onClick={() => setDetalle(null)}>
          <div className="modal" style={{ width: 680 }} onClick={e => e.stopPropagation()}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 16 }}>
              <div>
                <h2 style={{ marginBottom: 4 }}>{detalle.nombre}</h2>
                <span className={`badge ${detalle.estado}`}>{ESTADO_LABELS[detalle.estado]}</span>
              </div>
              <div style={{ display: 'flex', gap: 8 }}>
                <button className="btn btn-secondary" style={{ fontSize: '0.82rem' }} onClick={() => { setDetalle(null); abrirEditar(detalle); }}>✏️ Editar</button>
                <button className="btn btn-secondary" style={{ fontSize: '0.82rem' }} onClick={() => setDetalle(null)}>✕ Cerrar</button>
              </div>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '6px 24px', fontSize: '0.88rem', color: '#555', marginBottom: 8 }}>
              {detalle.urbanizacion && <p style={{ gridColumn: '1/-1', color: '#4f8ef7', fontWeight: 600 }}>🏘 {detalle.urbanizacion}</p>}
              <p>📍 {detalle.direccion}</p>
              <p>🗺 {detalle.departamento}{detalle.codigo_postal ? ` · CP ${detalle.codigo_postal}` : ''}</p>
              {detalle.localidad && <p>📌 {detalle.localidad}, {detalle.ciudad}</p>}
              {detalle.tipo && <p>🏠 {detalle.tipo.replace(/_/g, ' ')}</p>}
              {detalle.superficie_total && <p>📐 {detalle.superficie_total} m²</p>}
              {detalle.padron && <p>📋 Padrón: {detalle.padron}</p>}
              {(detalle.dormitorios || detalle.banos) && <p>🛏 {detalle.dormitorios} dorm · 🚿 {detalle.banos} baños</p>}
              {detalle.garaje && <p>🚗 Tiene garaje</p>}
              {!detalle.es_propio && <p style={{ color: '#f39c12' }}>👤 Administración de tercero</p>}
            </div>
            {detalle.google_maps_url && (
              <a href={detalle.google_maps_url} target="_blank" rel="noreferrer"
                style={{ color: '#4f8ef7', fontSize: '0.85rem', display: 'block', marginBottom: 8 }}>
                📍 Ver en Google Maps →
              </a>
            )}
            {detalle.notas && <p style={{ fontSize: '0.85rem', color: '#888', marginBottom: 8 }}>📝 {detalle.notas}</p>}

            {/* Contratos del inmueble */}
            {contratosDetalle.length > 0 && <ContratosFicha contratos={contratosDetalle} docs={docsContratos} />}

            <hr style={{ border: 'none', borderTop: '1px solid #f0f0f0', margin: '16px 0' }} />
            <Documentos entidadTipo="inmueble" entidadId={detalle.id} />
          </div>
        </div>
      )}

      {modal && (
        <div className="modal-overlay" onClick={cerrarModal}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <h2>{editando ? 'Editar inmueble' : 'Nuevo inmueble'}</h2>
            <form onSubmit={handleSubmit}>
              <div className="form-grid">

                <div className="form-group full">
                  <label>Nombre *</label>
                  <input name="nombre" value={form.nombre} onChange={handleChange} placeholder="Ej: Apto 2B Pocitos" required />
                </div>

                <div className="form-group">
                  <label>Tipo</label>
                  <select name="tipo" value={form.tipo} onChange={handleChange}>
                    {TIPOS.map(t => <option key={t} value={t}>{t.replace(/_/g, ' ')}</option>)}
                  </select>
                </div>

                <div className="form-group">
                  <label>Estado</label>
                  <select name="estado" value={form.estado} onChange={handleChange}>
                    {Object.entries(ESTADO_LABELS).map(([v, l]) => <option key={v} value={v}>{l}</option>)}
                  </select>
                </div>

                <div className="form-group full">
                  <label>Dirección *</label>
                  <input name="direccion" value={form.direccion} onChange={handleChange} required />
                </div>
                <div className="form-group full">
                  <label>Urbanización</label>
                  <input name="urbanizacion" value={form.urbanizacion} onChange={handleChange} placeholder="Ej: Huertas de los Horneros" />
                </div>

                {/* Departamento */}
                <div className="form-group">
                  <label>Departamento</label>
                  <select name="departamento" value={form.departamento} onChange={handleChange}>
                    <option value="">Seleccionar...</option>
                    {DEPARTAMENTOS.map(d => <option key={d} value={d}>{d}</option>)}
                  </select>
                </div>

                {/* Localidad */}
                <div className="form-group">
                  <label>Localidad</label>
                  {sugerenciasLocalidad.length > 0 ? (
                    <select name="localidad" value={form.localidad} onChange={handleChange}>
                      <option value="">Seleccionar...</option>
                      {sugerenciasLocalidad.map(l => <option key={l} value={l}>{l}</option>)}
                    </select>
                  ) : (
                    <input name="localidad" value={form.localidad} onChange={handleChange} placeholder="Ingresá la localidad" />
                  )}
                </div>

                {/* Ciudad */}
                <div className="form-group">
                  <label>Ciudad</label>
                  <input name="ciudad" value={form.ciudad} onChange={handleChange} />
                </div>

                {/* Código postal */}
                <div className="form-group">
                  <label>Código postal</label>
                  <input
                    name="codigo_postal"
                    value={form.codigo_postal}
                    onChange={handleChange}
                    placeholder="Ej: 20100"
                    maxLength={5}
                  />
                  {form.codigo_postal.length === 5 && !CODIGOS_POSTALES[form.codigo_postal] && (
                    <span style={{ fontSize: '0.75rem', color: '#aaa' }}>CP no encontrado en la base local</span>
                  )}
                  {form.codigo_postal.length === 5 && CODIGOS_POSTALES[form.codigo_postal] && (
                    <span style={{ fontSize: '0.75rem', color: '#2ecc71' }}>✓ {CODIGOS_POSTALES[form.codigo_postal].localidad}</span>
                  )}
                </div>

                <div className="form-group">
                  <label>Superficie total (m²)</label>
                  <input name="superficie_total" type="number" value={form.superficie_total} onChange={handleChange} />
                </div>

                <div className="form-group">
                  <label>Padrón</label>
                  <input name="padron" value={form.padron} onChange={handleChange} />
                </div>

                <div className="form-group">
                  <label>Dormitorios</label>
                  <input name="dormitorios" type="number" value={form.dormitorios} onChange={handleChange} />
                </div>

                <div className="form-group">
                  <label>Baños</label>
                  <input name="banos" type="number" value={form.banos} onChange={handleChange} />
                </div>

                <div className="form-group full">
                  <label>Ubicación en Google Maps</label>
                  <div style={{ display: 'flex', gap: 8 }}>
                    <input
                      name="google_maps_url"
                      value={form.google_maps_url}
                      onChange={handleChange}
                      placeholder="Pegá la URL de Google Maps o generala automáticamente"
                      style={{ flex: 1 }}
                    />
                    <button
                      type="button"
                      className="btn btn-secondary"
                      style={{ whiteSpace: 'nowrap', fontSize: '0.82rem' }}
                      onClick={() => {
                        const direccionCompleta = [form.direccion, form.localidad, form.ciudad, form.departamento, 'Uruguay']
                          .filter(Boolean).join(', ');
                        const url = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(direccionCompleta)}`;
                        setForm(f => ({ ...f, google_maps_url: url }));
                        window.open(url, '_blank');
                      }}
                    >
                      📍 Buscar en Maps
                    </button>
                  </div>
                  {form.google_maps_url && (
                    <div style={{ marginTop: 6, display: 'flex', alignItems: 'center', gap: 8 }}>
                      <a href={form.google_maps_url} target="_blank" rel="noreferrer" style={{ color: '#4f8ef7', fontSize: '0.82rem' }}>
                        Ver ubicación en Google Maps →
                      </a>
                    </div>
                  )}
                </div>

                <div className="form-group full">
                  <label>Notas</label>
                  <textarea name="notas" value={form.notas} onChange={handleChange} rows={3} />
                </div>

                <div className="form-group" style={{ flexDirection: 'row', alignItems: 'center', gap: 8 }}>
                  <input name="garaje" type="checkbox" checked={form.garaje} onChange={handleChange} style={{ width: 'auto' }} />
                  <label>Tiene garaje</label>
                </div>

                <div className="form-group" style={{ flexDirection: 'row', alignItems: 'center', gap: 8 }}>
                  <input name="es_propio" type="checkbox" checked={form.es_propio} onChange={handleChange} style={{ width: 'auto' }} />
                  <label>Es propiedad propia</label>
                </div>
              </div>

              <div className="modal-actions">
                <button type="button" className="btn btn-secondary" onClick={cerrarModal}>Cancelar</button>
                <button type="submit" className="btn btn-primary">{editando ? 'Guardar cambios' : 'Guardar'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
